const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        const squares = entry.target.querySelectorAll('.sign__item');
        const isSmallScreen = window.innerWidth < 576;

        if (entry.isIntersecting) {
            squares.forEach((square, index) => {
                const delay = isSmallScreen ? index * 500 : Math.floor(index / 2) * 1000;
                
                if (isSmallScreen || index % 2 === 0) {
                    setTimeout(() => {
                        square.classList.add('appear-animation');
                        
                        if (!isSmallScreen && squares[index + 1]) {
                            squares[index + 1].classList.add('appear-animation');
                        }
                    }, delay);
                }
            });
        } else {
            squares.forEach(square => {
                square.classList.remove('appear-animation');
            });
        }
    });
});

observer.observe(document.querySelector('.sign__inner'));
